import GoogleMap from '../modules/google_map'

up.compiler('[map-preview]', (element, data) => {

  let googleMap = undefined

  const apiKey = data.apiKey
  const location = data.location
  const mapData = data.mapData

  const mapElement = up.element.createFromHTML('<div class="map-content" />')
  element.appendChild(mapElement)

  new GoogleMap(mapElement, apiKey, location, mapData).then((instance) => {
    googleMap = instance
  })

});
